import React from 'react';
import './TextArea.css';

const Input = React.forwardRef(({ className = '', ...props }, ref) => (
  <textarea
    ref={ref}
    className={`text-area-input ${className}`}
    {...props}
  />
));

const TextArea = ({ label, children, className = '', ...props }) => {
  return (
    <div className={`text-area ${className}`} {...props}>
      {label && <label className="text-area-label">{label}</label>}
      {children}
    </div>
  );
};

TextArea.Input = Input;

export { TextArea }; 